// extracted by mini-css-extract-plugin
export default {"button":"yKxFcm0fUxNuaVJ1SFvp"};